/* istanbul ignore file */

import React, { Fragment, useEffect, useState } from 'react';

import * as style from './FooterLinks.styles';
import { Accordion } from 'client-site-chrome-ui/components/molecules/Accordion/Accordion';
import { FooterLinksHeading } from 'client-site-chrome-ui/components/molecules/FooterLinks/FooterLinksHeading';
import { FooterLinksList } from 'client-site-chrome-ui/components/molecules/FooterLinks/FooterLinksList';
import { getFooterLinks } from 'client-site-chrome-ui/content/footerLinks';

export const FooterLinks = () => {
  const sections = getFooterLinks();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      <div css={style.mobileWrapper} data-testid="footer__links--mobile">
        {sections.map(({ links, title }) => (
          <Fragment key={title}>
            {isClient ? (
              <Accordion heading={<FooterLinksHeading title={title} />} key={title}>
                <FooterLinksList links={links} sectionTitle={title} />
              </Accordion>
            ) : (
              <FooterLinksList key={title} links={links} sectionTitle={title} />
            )}
          </Fragment>
        ))}
      </div>
      <div css={style.desktopWrapper} data-testid="footer__links--desktop">
        <ul css={[style.list]}>
          {sections.map(({ links, title }) => (
            <li key={title}>
              <span css={style.title}>{title}</span>
              <FooterLinksList links={links} sectionTitle={title} />
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
